<script>
  import { onMount } from 'svelte';

  export let synced = true;
  export let moving = true;
  export let style = '';

  let el;

  const findAnimByName = (elem, animationName) => {
    const anims = elem.getAnimations();
    return anims.find((anim) => anim.animationName.match(animationName));
  };

  onMount(() => {
    if (synced && moving) {
      // If the preload box should be "synced", then we want its animation timing to be synced up
      // with the animations from the rest of the "synced" preload boxes on the page.
      // Since groups of these can render and re-render at different times, the safest/surest
      // way is to find the "oldest" PreloadBox, and use its animation's "startTime" as the
      // source of truth to sync with.
      //
      // This function sets an attribute of preloadBoxCount on the element, and also looks for
      // the oldest PreloadBox on the page (based on its preloadBoxCount), and then sets the
      // animation startTime of the current element to be in sync with the animation of that
      // oldest element.
      el.addEventListener('animationstart', (_evt) => {
        const otherBoxes = [...document.querySelectorAll('.preload--box.synced.moving')];

        if (otherBoxes.length === 0) {
          return;
        }

        const preloadBoxCounts = otherBoxes.map((box) => box.preloadBoxCount).filter((count) => !!count);
        const highestPreloadBoxCount = Math.max(...preloadBoxCounts, 0);

        el.preloadBoxCount = highestPreloadBoxCount + 1;

        const lowestPreloadBoxCount = Math.min(...preloadBoxCounts);
        const oldestBox = otherBoxes.find((box) => box.preloadBoxCount === lowestPreloadBoxCount);

        if (!oldestBox) {
          return;
        }

        try {
          const thisGradient = findAnimByName(el, 'gradient');
          const otherGradient = findAnimByName(oldestBox, 'gradient');
          thisGradient.startTime = otherGradient.startTime;
        } catch {}
      });
    }
  });
</script>

<style style="text/scss" lang="scss">
  .preload--box {
    height: 100%;
    width: 100%;
    border-radius: 12px;
    background: linear-gradient(320.69deg, #efefef 36.36%, hsla(0, 0%, 97.6%, 0.505208) 50.4%, #efefef 93.02%);
    background-size: 200% 200%;
    animation: gradient 3s ease infinite;

    &:not(.moving) {
      animation: none;
    }
  }

  @-webkit-keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }

  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
</style>

<div style={style} class="preload--box" class:synced={synced} class:moving={moving} bind:this={el}>&nbsp;</div>
